import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/ui.d.ts').Input}
 */
const Input = (props) => {
    return (
        <div className='relative z-0'>
            <input
                {...props}
                className='floating-label__input peer w-full'
                id={props.id}
                placeholder=' ' />

            <label
                className='floating-label__label peer-focus:start-0 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-[0.8] peer-focus:-translate-y-[13px]'
                htmlFor={props.id}>
                {props.label}
            </label>
        </div>
    );
};

/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export default Input;
